import { useEffect, useState } from "react";
import SiteNav from "@/components/feature/SiteNav";
import SiteFooter from "@/components/feature/SiteFooter";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import FeaturedSection from "./components/FeaturedSection";
import CatalogSection from "./components/CatalogSection";
import RankingSection from "./components/RankingSection";
import PlotSection from "./components/PlotSection";
import GuideSection from "./components/GuideSection";
import CharacterSection from "./components/CharacterSection";
import ReviewSection from "./components/ReviewSection";
import FaqSection from "./components/FaqSection";
import MoreSection from "./components/MoreSection";
import { useReveal } from "@/hooks/useReveal";

export default function Home() {
  useReveal();
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 800);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="min-h-screen bg-background-50">
      <SiteNav />
      <main>
        <HeroSection />
        <AboutSection />
        <FeaturedSection />
        <CatalogSection />
        <RankingSection />
        <PlotSection />
        <GuideSection />
        <CharacterSection />
        <ReviewSection />
        <FaqSection />
        <MoreSection />
      </main>
      <SiteFooter />

      {showTop && (
        <button
          type="button"
          aria-label="回到顶部"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="fixed bottom-6 right-5 z-40 w-11 h-11 flex items-center justify-center rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer"
        >
          <i className="ri-arrow-up-line text-xl" aria-hidden="true"></i>
        </button>
      )}
    </div>
  );
}